<template>
  <div>
    <iModal
      title="新增文件"
      v-model="showModal"
      class-name="common-ad-down"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="车证模版：" :required="true">
              <div class="my-upload">
                <Upload
                  ref="upload"
                  :on-success="handleSuccess"
                  :headers="formHeaders"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  :format="fileType"
                  :on-format-error="formatError"
                  :on-exceeded-size="handleMaxSize"
                  :max-size="51200"
                >
                  <Button icon="ios-cloud-upload-outline" :disabled="uploading">上传文件</Button>
                </Upload>
           <p>仅支持 docx 文件</p>

              </div>
            </FormItem>
              <p class="text-overflow" v-if="templateUrl" @click.stop="urlGo">{{templateUrl}}</p>
              <p style="font-size:12px;" v-if="uploadType == '2'">支持替换的关键字：展商展位号：[展商展位号]、公司名称：[公司名称]、展商联系人：[展商联系人]、展商联系人手机号：[展商联系人手机号]、撤展司机联系人：[撤展司机联系人]、撤展司机联系人手机号：[撤展司机联系人手机号]、撤展车牌号：[撤展车牌号]。</p>
              <p style="font-size:12px;" v-if="uploadType == '1'">支持替换的关键字：展商展位号：[展商展位号]、公司名称：[公司名称]、展商联系人：[展商联系人]、展商联系人手机号：[展商联系人手机号]、布展司机联系人：[布展司机联系人]、布展司机联系人手机号：[布展司机联系人手机号]、布展车牌号：[布展车牌号]。</p>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ad-home-down",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    downType: {
      type: String,
      default: "中文文件"
    },
    uploadType: {
      type: String,
      default: "1"
    },
    templateUrl: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formInline: {
        path: "",
        name: "",
        showIndex: 0
      },
      ruleInline: {
        name: [{ required: true, message: "请输入文件名", trigger: "blur" }]
      },
      uploadList: [],
      defaultList: [],
      visible: false,
      fileType: [
        "docx",
      ],
      uploading: false,
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl2",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      exhibition: "hostSetModule/getHostExhibition",
    })
  },
  created() {},
  methods: {
    ...mapActions({
      addDown: "hostDownModule/addDown",
      cardTemplateUrl: "hostSetModule/cardTemplateUrl",
    }),
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove(file) {},
    // 上传成功
    handleSuccess(res, file) {
      this.uploading = false;
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.formInline.path = file.url;
        if (file.name) {
          let strFileName = file.name.replace(/(.*\/)*([^.]+).*/gi, "$2");
          this.formInline.name = strFileName;
        }
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
    //   let valid = await this.validForm(name);
    //   if (!valid) return;
      if (!form.path) {
        this.$Message.warning(`请上传文件！`);
        return;
      }
     
      let req = {
        exhibitionId: this.exhibition.id,
        templateUrl: form.path,
        type: this.uploadType == '2' ? 'Dismantling' : 'ExhibitionArrange',
        mapUrl: "https://oss.cmef.com.cn/cloudExhibition/imgs/202403/0db3292ee7b14530bef5fc02644da4cd.png",
      };
      this.loading = true;
      let bool = await this.cardTemplateUrl(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      } else {
        this.cancel();
        this.$emit("finish");
        this.loading = false;
        this.$Message.success("添加成功！");
      }
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次最多上传${limitNum}个文件`);
      }
      if (check) {
        this.uploading = true;
      }
      return check;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.formInline.title = "";
      this.formInline.link = "";
      this.formInline.showIndex = 0;
      this.uploadList = [];
      this.uploading = false;
      this.$refs.upload.fileList = [];
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    },
    handleMaxSize(file) {
      this.uploading = false;
      this.$Message.warning(`文件大小超过限制, 请上传小于50M以下的文件`);
    },
    formatError(file) {
      this.uploading = false;
      this.$Message.warning(`文件格式错误，请重新上传`);
    },
    urlGo(){
      window.open(this.templateUrl,'_blank')
    },
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
.text-overflow {
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏超出的内容 */
  text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
  max-width: 100%; /* 设置最大宽度以限制文本的显示长度 */
  cursor: pointer;
  color: rgb(24, 144, 255);
}

</style>
<style lang="scss">
  .common-ad-down{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
        top: 0;
    }
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    // IE10+ CSS styles go here
    .common-ad-down{
      display: block;
      .ivu-modal{
        top: 150px;
      }
    }
  }
</style>
